import { useRef } from "react";
import { useFormikContext } from "formik";
import { Container, Card } from 'react-bootstrap';
import { Divider } from '@mui/material';
import { Step1, Step2, Step3, Step4, Step5, Step6 } from "../../1-SendLeaseByManager/Steps";
import { Footer } from '../../components';

const EditLease = () => {
    const leaseFormRef = useRef(null);
    const formik = useFormikContext();

    const steps = [
        { label: 'Step 1', component: <Step1 formik={formik} isEditMode={true} /> },
        { label: 'Step 2', component: <Step2 formik={formik} isEditMode={true} /> },
        { label: 'Step 3', component: <Step3 formik={formik} isEditMode={true} /> },
        { label: 'Step 4', component: <Step4 formik={formik} isEditMode={true} /> },
        { label: 'Step 5', component: <Step5 formik={formik} isEditMode={true} /> },
        { label: 'Step 6', component: <Step6 formik={formik} isEditMode={true} /> },
    ];

    if (!formik) {
        return (
            <Container className="py-5 text-center">
                <div>Loading lease form data...</div>
            </Container>
        );
    }

    return (
        <Card className="shadow-lg p-5 lease-form-creation" style={{ backgroundColor: 'white' }}>
            <Card.Body ref={leaseFormRef}>
                {steps.map((step, index) => (
                    <div key={index} className="mb-4 lease-step">
                        {step.component}
                        <Footer values={formik.values} page={index + 1} />
                        {index < steps.length - 1 && (
                            <Divider sx={{ my: 4, borderColor: 'gray' }} />
                        )}
                    </div>
                ))}
            </Card.Body>
        </Card>
    );
}

export { EditLease }